import { Component } from "preact";
import actions from "../../actions";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import { FILTER_TYPE, SETTING_KEYS } from "../../constants";
import { getSetting } from "../../../common/helpers/settingStorageHelpers";
import AdvancedFilter from "./advanced/AdvancedFilter";
import { persistSettings } from "../../../calendar-common/helpers/settingsHelper";

class MobileFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: {
                type: null,
                time: null,
                dateRange: { from: null, to: null },
                categories: null,
                volatilities: null,
                countries: null,
                eventName: "",
            },
            timezoneOffset: null,
            persistSettings: false,
        };

        this.applyFilter = this.applyFilter.bind(this);
        this.onMyFilterClick = this.onMyFilterClick.bind(this);
        this.onDefaultsClick = this.onDefaultsClick.bind(this);
    }

    componentWillMount() {
        const { settings } = this.props;
        this.setState({
            filter: settings.filter,
            timezoneOffset: settings.timezoneOffset,
        });
    }

    applyFilter() {
        this.props.changeFilter({
            ...this.state.filter,
            type: this.state.persistSettings
                ? FILTER_TYPE.custom
                : this.state.filter.type,
        });
        this.props.changeTimezone(this.state.timezoneOffset);

        this.props.fetchEventDates();
        this.props.changeShowMobileFilter(false);

        if (this.state.persistSettings) {
            persistSettings({
                ...this.props.settings,
                filter: { ...this.state.filter, type: FILTER_TYPE.custom },
                timezoneOffset: this.state.timezoneOffset,
            });
        }
    }

    onDefaultsClick() {
        const defaultSettings = { ...this.props.defaultSettings };
        defaultSettings.filter.type = FILTER_TYPE.default;
        this.setState({
            ...defaultSettings,
            persistSettings: this.state.persistSettings,
        });
    }

    onMyFilterClick() {
        const settings = getSetting(SETTING_KEYS.Settings);
        settings.filter.type = FILTER_TYPE.custom;
        if (settings)
            this.setState({
                ...settings,
                persistSettings: this.state.persistSettings,
            });
    }

    render({ settings }) {
        return (
            <div class="fxs_c_mobile-filters-wrapper">
                <AdvancedFilter filter={settings.filter} />
            </div>
        );
    }
}

export default connectWithTranslations(
    "settings, defaultSettings, config",
    actions
)(MobileFilter);
